import { SyntheticEvent, useCallback, useState } from "react";
import { AutocompleteInputChangeReason } from "@mui/material";

export const useDynamicAutocomplete = (initialOptions: string[]) => {
    const [options, setOptions] = useState<string[]>(initialOptions);

    const handleInputChange = useCallback(
        (
            _event: SyntheticEvent,
            value: string,
            reason: AutocompleteInputChangeReason,
        ) => {
            if (reason === "input" && value && !options.includes(value)) {
                setOptions((prev) => [...prev, value]);
            }
        },
        [options],
    );

    return { options, handleInputChange };
};
